import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { SimpleGrid, Paper, Text, Group } from "@mantine/core";
import { useServerApi } from "../../hooks/userServerApi";

const McaStatCards = ({ stats }) => {
  const cards = [
    { label: "Pending Approval", value: stats?.pendingApproval ?? 0, color: "yellow" },
    { label: "In Progress", value: stats?.IN_PROGRESS ?? 0, color: "blue" },
    { label: "Approved", value: stats?.APPROVED ?? 0, color: "green" },
    { label: "Rejected", value: stats?.REJECTED ?? 0, color: "red" },
  ];

  return (
    <SimpleGrid cols={4} mb="lg">
      {cards.map((card) => (
        <Paper key={card.label} p="md" withBorder radius="md">
          <Text size="xs" color="dimmed" transform="uppercase" weight={600}>
            {card.label}
          </Text>
          <Group position="apart" mt="xs">
            <Text size="xl" weight={700}>
              {card.value}
            </Text>
          </Group>
        </Paper>
      ))}
    </SimpleGrid>
  );
};

const buildMcaStatsPreQuery = (tab) => {
  if (tab === "pending") return { _mcaTab: "pending" };
  if (tab === "submitted") return { makerOnly: true };
  return {};
};

const McaPageStats = forwardRef(({ mb = 35, tab = "all" }, ref) => {
  const [api] = useServerApi();
  const [stats, setStats] = useState({});

  const load = async () => {
    const res = await api.Mca.getStatSummary(buildMcaStatsPreQuery(tab));
    setStats(res?.data ?? {});
  };

  useImperativeHandle(ref, () => ({ refresh: load }));

  useEffect(() => {
    load();
  }, [tab]);

  return (
    <div style={{ marginBottom: mb }}>
      <McaStatCards stats={stats} />
    </div>
  );
});

McaPageStats.displayName = "McaPageStats";

export default McaPageStats;
